import type { VideoPlayerProps } from './component';
import type { FC } from 'react';
import { lazy, memo, Suspense } from 'react';

const ComponentLoad = lazy(async () => await import('./component'));

const VideoPlayer: FC<VideoPlayerProps> = props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
);

export default memo(VideoPlayer);
